<svelte:options customElement="icon-logo" />

<script lang="ts">
	interface Props {
		height?: number;
	}

	let { height = 17 }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" {height} viewBox="0 0 20 20" fill="none">
	<path
		fill="#CFFAC7"
		d="M0 4.612A4.612 4.612 0 0 1 4.612 0h1.477c.905 0 1.639.734 1.639 1.64v4.449a1.64 1.64 0 0 1-1.64 1.639H1.64A1.64 1.64 0 0 1 0 6.088V4.613Z"
	/>
	<path
		fill="#26970D"
		d="M3.864 5.434c0-.867.703-1.57 1.57-1.57h2.294v2.57c0 .714-.58 1.294-1.294 1.294h-2.57V5.434Z"
	/>
	<path
		fill="#CFFAC7"
		d="M0 11.492a4.612 4.612 0 0 0 4.612 4.611h1.477a1.64 1.64 0 0 0 1.639-1.639v-4.45a1.64 1.64 0 0 0-1.64-1.639H1.64A1.64 1.64 0 0 0 0 10.015v1.476Z"
	/>
	<path
		fill="#26970D"
		d="M3.864 10.67c0 .867.703 1.57 1.57 1.57h2.294V9.67c0-.715-.58-1.295-1.294-1.295h-2.57v2.295Z"
	/>
	<path
		fill="#CFFAC7"
		d="M16 11.492a4.612 4.612 0 0 1-4.612 4.611H9.911a1.64 1.64 0 0 1-1.639-1.639v-4.45c0-.905.734-1.639 1.64-1.639h4.449c.905 0 1.639.734 1.639 1.64v1.476Z"
	/>
	<path
		fill="#26970D"
		d="M12.136 10.67a1.57 1.57 0 0 1-1.57 1.57H8.272V9.67c0-.715.58-1.295 1.294-1.295h2.57v2.295ZM16 4.612A4.612 4.612 0 0 0 11.388 0H9.911a1.64 1.64 0 0 0-1.639 1.64v4.449c0 .905.734 1.639 1.64 1.639h4.449A1.64 1.64 0 0 0 16 6.088V4.613Z"
	/>
	<path
		fill="#CFFAC7"
		d="M12.136 5.434a1.57 1.57 0 0 0-1.57-1.57H8.272v2.57c0 .714.58 1.294 1.294 1.294h2.57V5.434Z"
	/>
</svg>
